<template>
  <div class="form-inline-group inline form-amount">
    <FormFieldOptions
      v-bind="{
        index: 999,
        options,
        title,
        type: 'radio',
      }"
      v-model="value"
      use-value
      class="form-amount-options"
      inline
      @click="active = false"
    />
    <!-- <label
      v-for="amount in amounts"
      :id="attrs.name + '-' + amount"
      :class="`form-amount-option-${amount}`"
      type="radio"
      :name="amount"
      :value="amount"
      :active="active === amount"
      v-text="`£${amount}`"
    /> -->
    <label class="form-label form-amount-custom" :class="{ active }" @click="active= true">
      <span class="form-label-text">Other</span>
      <span class="form-input-price">£</span>
      <input
        :id="attrs.name + '-custom'"
        v-model="value"
        type="number"
        class="form-input"
      />
    </label>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  index: { type: Number, default: 0 },
  modelValue: [String, Number, Boolean, Array],
  title: String,
  attrs: Object,
  suggestedAmounts: {
    type: Array,
    default: () => [5, 10, 20],
  },
})
const emit = defineEmits(['update:modelValue'])

const options = props.suggestedAmounts.map((a) => ({
  label: `£${a}`,
  value: a,
}))
// .map(o => typeof o === 'number' ? ({
//   value: o,
//   title: `£${o}`
// }) : o)

const active = ref(false)

const value = computed({
  get: () => props.modelValue,
  set: (value) => 
    emit('update:modelValue', value),
})
</script>

<style lang="scss">
.form-amount {
  .form-amount-options {
    flex-flow: row !important;
    margin-bottom: czn.$md;
    width: 100%;
  }

  .form-label {
    position: relative;
    display: flex;
    margin: czn.$sm;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    .form-toggle {
      display: none;
    }
    border-radius: var(--br-items-sm);

    .form-input.form-radio {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      border: 2px solid transparent;
      appearance: none;
      opacity: 1;
      background: var(--field-bg);
      z-index: 0;

      &:checked {
        border-color: darkgreen;

        background: rgba(darkgreen, 0.2);
      }

      + .form-option-text {
        padding: czn.$md + czn.$rg czn.$lg czn.$md czn.$lg + czn.$sm;
        margin: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        z-index: 10;
      }
    }

    &:hover,
    &:focus,
    &:active {
      border-color: var(--field-accent);
    }

    &-custom {
      display: none;
    }
  }

  .form-amount-custom {
    opacity: 0.4;
    &.active {
      opacity: 1;
      .form-input {
        border-color: darkgreen;

        background: rgba(darkgreen, 0.2);
      }
    }
    .form-label-text {
      padding: 0 czn.$rg 0 czn.$sm;
      margin: 0;
      &::after {
        display: none;
      }
    }

    .form-input-price {
      margin-right: -2.5rem;
    }

    .form-input {
      padding-left: czn.$lg + czn.$rg;
      font-size: 1.5rem;
      font-weight: 300;
      font-family: var(--font-body);
    }
  }
}
</style>
